import { MenuItem, Select as MuiSelect } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSelect = styled(MuiSelect)({
  '&.MuiInputBase-root': {
    border: 'none',
    backgroundColor: '#fff',
    boxShadow: '0 2px 15px 0 rgba(0, 0, 0, 0.05)',
    transition: 'box-shadow 0.25s ease-in-out',

    '&:hover': {
      boxShadow: '0 4px 15px 0 rgba(43, 87, 185, 0.15)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  '& .MuiSelect-select': {
    display: 'flex',
    padding: '15.5px 12px',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    color: '#2b39b9',
    letterSpacing: 0.2,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#2b39b9',
  },
});

export const StyledMenuItem = styled(MenuItem)({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 12px',
  letterSpacing: 0.112,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  '&.Mui-selected, &.Mui-focused, &.Mui-selected.Mui-focusVisible': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
});
